import React, { Component, Fragment } from "react";
import moment from "moment";

import PrintOrderList from "./PrintOrderList";
import MarketPrintOrder from "./MarketPrintOrder";


const MarketUserHeader = ({
  order,
  orderId,
  orderStatus,
  orderDate,
  deliveryDate,
  isReceivingOrder,
  buttonAction,
  printOrder,
  showItemsWithZeroQty,
}) => {
  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-no-bottom-margin">
            <div className="card-header-grey d-flex justify-content-between align-items-center">
              <h4>My Order</h4>
              <div className="hidden-xs-down">
                <button type="button" className="btn btn-primary m-0 mr-1" onClick={printOrder}>
                  <i className="fa fa-print mr-05" />
                  Print
                </button>
                <button type="button" className="btn btn-primary m-0" onClick={buttonAction}>
                  <i className={`mr-05 fa ${isReceivingOrder ? 'fa-flag-checkered' : 'fa-copy'}`} />
                  {isReceivingOrder ? 'Confirm received' : 'Order again'}
                </button>
              </div>
              <div className="hidden-sm-up">
                <button type="button" className="btn btn-sm btn-primary m-0 mr-1" onClick={printOrder}>
                  <i className="fa fa-print" />
                </button>
                <button type="button" className="btn btn-sm btn-primary m-0" onClick={buttonAction}>
                  <i className={`fa ${isReceivingOrder ? 'fa-flag-checkered' : 'fa-copy'}`} />
                </button>
              </div>
            </div>
            <MarketPrintOrder order={order} orderDate={orderDate} deliveryDate={deliveryDate} showItemsWithZeroQty={showItemsWithZeroQty} />
            <iframe title="toPrintOrder" id="marketOrderPrint" style={{ display: "none" }}></iframe>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-subheader d-flex justify-content-between align-items-center">
            <div className="d-flex flex-row align-items-center">
              <div className="pr-1 font-weight-medium">Order #{orderId}</div>
              <span className={`badge badge-pill custom-badge ${orderStatus.badgeClass}`}>{orderStatus.name}</span>
            </div>
            <div className="font-weight-light">{orderDate}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PlantUserHeader = ({
  items,
  stations,
  orderId,
  orderStatus,
  orderIsPreparing,
  orderMarket,
  deliveryDate,
  orderOwner,
  orderDate,
  printOrder,
  goToShipment,
  handleDelete,
  showItemsWithZeroQty
}) => {
  const button = (
    <div className="d-flex">
      <button type="button" className="btn btn-primary m-0 hidden-xs-down" onClick={() => goToShipment()}>
        <i className="fa fa-truck mr-05" /> Go to Shipment
      </button>
      {orderIsPreparing && (
        <Fragment>
          <button type="button" className="btn btn-primary m-0 ml-1 hidden-xs-down" onClick={() => printOrder(stations)}>
            <i className="fa fa-print mr-05"></i> Print order
          </button>
          <span className="ml-1 btn btn-danger mr-0 hidden-xs-down" onClick={handleDelete}>
            <i className="fa fa-trash"></i>
          </span>
        </Fragment>
      )}
      {/* Small Action Buttons */}
      <button type="button" className="btn btn-sm btn-primary m-0 hidden-sm-up" onClick={() => goToShipment()}>
        <i className="fa fa-truck" />
      </button>
      {orderIsPreparing && (
        <Fragment>
          <button type="button" className="btn btn-sm btn-primary m-0 hidden-sm-up ml-05" onClick={() => printOrder(stations)}>
            <i className="fa fa-print" />
          </button>
          <span className="ml-05 btn btn-sm btn-danger mr-0 hidden-sm-up" onClick={handleDelete}>
            <i className="fa fa-trash"></i>
          </span>
        </Fragment>
      )}
      {orderIsPreparing && stations &&
        stations.map((station, index) => (
          <div id={index} key={index}>
            <PrintOrderList
              index={index}
              station={station}
              orderId={orderId}
              orderMarket={orderMarket}
              orderOwner={orderOwner}
              orderDate={orderDate}
              deliveryDate={deliveryDate}
              items={items.filter((item) => item.station === station)}
              showItemsWithZeroQty={showItemsWithZeroQty}
            />
          </div>
        ))}
      <iframe title="toPrintOrder" id="ifmcontentstoprint" style={{ display: "none" }}></iframe>
    </div>
  );

  return (
    <div className="card">
      <div className="row">
        <div className="col-sm-12">
          <div className="card-header-grey d-flex justify-content-between align-items-center">
            <div className="d-flex flex-row align-items-center">
              <h4 className="pr-1 font-weight-medium no-margin-bottom">Order #{orderId}</h4>
              <span className={`badge badge-pill custom-badge ${orderStatus.badgeClass}`}>{orderStatus.name}</span>
            </div>
            {button}
          </div>
        </div>
      </div>
      <div className="card-block">
        <div className="row">
          <div className="col-sm-3">
            <h5>Market</h5>
            <p>{orderMarket}</p>
          </div>
          <div className="col-sm-3">
            <h5>User</h5>
            <p>{orderOwner}</p>
          </div>
          <div className="col-sm-3">
            <h5>Date</h5>
            <p>{orderDate}</p>
          </div>
          <div className="col-sm-3">
            <h5>Delivery Date</h5>
            <p>{deliveryDate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export class OrderDetailHeader extends Component {
  printOrder(stations) {
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    for (var i = 0; i < stations.length; i++) {
      var content = document.getElementById("toPrint" + i);
      pri.document.write(content.innerHTML);
    }
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    }, 50);
  }

  printMarketOrder() {
    var pri = document.getElementById("marketOrderPrint").contentWindow;
    pri.document.open();
    var content = document.getElementById("marketOrderPrintContent");
    pri.document.write(content.innerHTML);
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    }, 50);
  }

  render() {
    const {
      order,
      isReceivingOrder,
      buttonAction,
      orderStatus,
      isPlantUser,
      goToShipment,
      handleDelete,
      showItemsWithZeroQty
    } = this.props;

    const {
      id: orderId,
      items,
      stations,
      created_by: orderOwner,
      market: orderMarket
    } = order;
    const orderDate = order ? moment(order.date).format("L") : "";
    const receivedDate = order ? moment(order.sent_to_market_date).format("L") : "";
    const deliveryDate = order ? moment(order.delivery_date).format("L") : "";
    return isPlantUser ? (
      <PlantUserHeader
        orderId={orderId}
        orderStatus={orderStatus}
        orderIsPreparing={orderStatus.id === 1}
        orderMarket={orderMarket}
        numberOfItems={items.length}
        orderOwner={orderOwner}
        orderDate={receivedDate}
        deliveryDate={deliveryDate}
        items={items}
        stations={stations}
        printOrder={this.printOrder}
        goToShipment={goToShipment}
        handleDelete={handleDelete}
        showItemsWithZeroQty={showItemsWithZeroQty}
      />
    ) : (
      <MarketUserHeader
        orderId={orderId}
        orderStatus={orderStatus}
        orderDate={orderDate}
        deliveryDate={deliveryDate}
        isReceivingOrder={isReceivingOrder}
        buttonAction={buttonAction}
        order={order}
        printOrder={this.printMarketOrder}
        showItemsWithZeroQty={showItemsWithZeroQty}
      />
    );
  }
}

export default OrderDetailHeader;
